export const APPOINTMENT_STATUS_CODE = {
  planned: 'planned',
  confirmed: 'confirmed',
  inPreparation: 'in_preparation',
  completed: 'completed',
  cancelled: 'cancelled',
  noShow: 'no_show',
} as const;

export type AppointmentStatusCode =
  (typeof APPOINTMENT_STATUS_CODE)[keyof typeof APPOINTMENT_STATUS_CODE];

export const APPOINTMENT_STATUS_CODE_OPTIONS: AppointmentStatusCode[] = [
  APPOINTMENT_STATUS_CODE.planned,
  APPOINTMENT_STATUS_CODE.confirmed,
  APPOINTMENT_STATUS_CODE.inPreparation,
  APPOINTMENT_STATUS_CODE.completed,
  APPOINTMENT_STATUS_CODE.cancelled,
  APPOINTMENT_STATUS_CODE.noShow,
];

export const THERAPY_TYPE_CODE = {
  firstConsultation: 'first_consultation',
  therapyContinuation: 'therapy_continuation',
  laserMls: 'laser_mls',
  manualTherapy: 'manual_therapy',
  individualExercises: 'individual_exercises',
  followUp: 'follow_up',
  other: 'other',
} as const;

export type TherapyTypeCode = (typeof THERAPY_TYPE_CODE)[keyof typeof THERAPY_TYPE_CODE];

export const THERAPY_TYPE_CODE_OPTIONS: TherapyTypeCode[] = [
  THERAPY_TYPE_CODE.firstConsultation,
  THERAPY_TYPE_CODE.therapyContinuation,
  THERAPY_TYPE_CODE.laserMls,
  THERAPY_TYPE_CODE.manualTherapy,
  THERAPY_TYPE_CODE.individualExercises,
  THERAPY_TYPE_CODE.followUp,
  THERAPY_TYPE_CODE.other,
];

export const DEFAULT_THERAPY_TYPE_CODE: TherapyTypeCode = THERAPY_TYPE_CODE.therapyContinuation;
export const DEFAULT_APPOINTMENT_STATUS_CODE: AppointmentStatusCode =
  APPOINTMENT_STATUS_CODE.planned;

export function buildAppointmentStatusTranslationKey(statusCode: string): string {
  return 'appointments:status.' + statusCode;
}

export function buildTherapyTypeTranslationKey(therapyTypeCode: string): string {
  return 'appointments:therapyType.' + therapyTypeCode;
}
